import { yup } from '@framework/validation';
import { ExpressionType } from '../../../../expressions/IExpression';
import { ExpressionValue } from '../../../../expressions/evaluate/ExpressionValue';
import { evaluateExpression } from '../../../../expressions/evaluate/evaluateExpression';
import { IFunctionExpression } from '../../../../expressions/repository/function/IFunctionExpression';
import { IParentWidgetScope } from '../../../IWidgetType';
import { IComputedNumberWidget } from '../IComputedWidget';
import { setComputeTransform } from '../setComputedTransform';

export function setComputedNumberTransform(
  widget: Pick<IComputedNumberWidget, 'expression'>,
  parentScope: IParentWidgetScope,
  schema: yup.AnySchema,
  /**
   * Funzione di trasformazione del risultato dell'espressione.
   */
  transform?: (value: ExpressionValue) => any,
) {
  // Costruisco la FunctionExpression così da poter usare
  // le funzionalità di risoluzione già esistenti
  const expression: IFunctionExpression = {
    type: ExpressionType.Function,
    value: widget.expression,
  };

  return setComputeTransform(
    expression,
    parentScope,
    schema,
    (expression: IFunctionExpression, variables: Record<string, any>) => {
      // Non possiamo fare questo tipo di filtro, in quanto le espressioni
      // **matematiche** considerano i valori nulli come **0**, es. se devo
      // fare una somma e uno dei valori è null, il risultato sarà il valore
      // non nullo.
      // Attenzione: questo porta a un comportamento chiaramente errato in caso
      // di divisione per 0, ma è un problema che è risolvibile in
      // configurazione.
      // In futuro possiamo prevedere un flag per invertire "considerNullsAsZero"
      //
      // if (Object.values(variables).some(v => v === undefined)) {
      // }

      const result = evaluateExpression(expression, { variables });

      return transform ? transform(result) : result;
    },
  );
}
